import React from "react";
import styled from "styled-components";
import { FiCheckCircle } from "react-icons/fi";

import logoWeb from "../../assets/images/web1_2.png"; //'../assets/images/logo/logo_web_wired.png';
import logoMobile from "../../assets/images/imgMobile1.png"; //'../assets/images/logo/logo_phoneapps_wired.png';
import logoPC from "../../assets/images/imgBureau1.png"; //'../assets/images/logo/logo_pc_wired.png';
import logoAppWeb from "../../assets/images/imgGestion1.png"; //'../assets/images/logo/logo_pc_wired.png';
import logoAds from "../../assets/images/imgAds.png"; //'../assets/images/logo/logo_pc_wired.png';
import { Inner } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import theme from "../../theme";
import AnimateOnScroll from "../../components/AnimateOnScroll";

// Animated title specific to this section
const OffersTitle = styled.h2`
  position: relative;
  font-size: 2rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--my-color3);
  margin: 0;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -6px;
    height: 4px;
    width: 100%;
    background: var(--my-color5);
    transform-origin: left;
    transform: scaleX(0);
    transition: transform 0.6s ease 0.3s;
  }

  &.underline {
    &::after {
      transform: scaleX(1);
    }
  }
`;

// Frame variant – vertical bars grow
const FrameTitle = styled.h2`
  position: relative;
  font-size: 2rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--my-color3);
  margin: 0;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 4px;
    background: var(--my-color5);
    transform: scaleY(0);
    transition: transform 0.6s ease 0.3s;
  }
  &::before {
    left: -12px;
  }
  &::after {
    right: -12px;
  }

  &.show::before,
  &.show::after {
    transform: scaleY(1);
  }
`;

// Marker highlight behind entire title
const MarkerTitle = styled.h2`
  position: relative;
  font-size: 2rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--my-color3);
  margin: 0;
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 0.6s ease,
    transform 0.6s ease;

  &.show {
    opacity: 1;
    transform: translateY(0);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 45%;
    width: 100%;
    background: var(--my-color5);
    opacity: 0.6;
    z-index: -1;
    transform-origin: left;
    transform: scaleX(0);
    transition: transform 0.6s ease 0.3s;
  }

  &.show::after {
    transform: scaleX(1);
  }
`;

const Section = styled.section`
  background-color: transparent;
  width: 100%;
  padding-bottom: 2rem;
  ${theme.breakpoints.down("sm")} {
    padding: 0rem 1rem;
  }
`;

// We use Inner for padding
const Container = styled(Inner)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  max-width: 1200px;
`;

const OffresContainer = styled.div`
  display: flex;
  width: 100%;
  justify-items: center;
  margin-top: 3rem;
  flex-wrap: wrap;
  justify-content: center;
  justify-content: space-evenly;

  ${theme.breakpoints.down("sm")} {
    gap: 3rem;
  }
`;

const AnimatedCard = styled(AnimateOnScroll)`
  width: 100%;
  max-width: 200px;
  display: flex;
  justify-content: center;
  ${theme.breakpoints.down("sm")} {
    max-width: 80%;
  }
`;

const Card = styled.div`
  background-color: #ffffff;
  padding: 1.5rem 1rem 1.5rem 1rem;
  border-radius: 16px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);

  width: 100%;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  height: 280px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 35px rgba(0, 0, 0, 0.15);
  }

  &.featured {
    border: 2px solid var(--my-color2);
  }

  hr {
    border: none;
    border-top: 2px solid var(--my-color2);
    margin: 0.5rem 0 0.4rem;
  }

  ${theme.breakpoints.down("sm")} {
    max-width: 90%;
    height: auto;
    min-height: -webkit-fill-available;
  }
`;

const CardImg = styled.div`
  width: 4rem;
  height: 4rem;
  margin: -1.5rem auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 6px solid var(--my-color3);
  background-color: white;
  overflow: hidden;
  transform: translateY(-50%);
  img {
    object-fit: contain;
    width: 4rem;
    height: 4rem;
  }
`;

const CardTitle = styled.h3`
  text-align: center;
  color: var(--my-color3);
  font-size: 1.15rem;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
  margin-top: -2rem;
  line-height: 1.3rem;
  min-height: 2.6rem; /* ensure 2 lines max, align hr */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubLabel = styled.div`
  text-align: center;
  font-size: 0.85rem;
  color: var(--my-color5);
  margin-top: 0.2rem;
`;

const Bullet = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.9rem;
  color: var(--my-color3);
  margin-bottom: 0.3rem;

  strong {
    color: var(--my-color5);
    font-weight: 600;
  }
  list-style: none;
  svg {
    color: var(--my-color5);
    flex-shrink: 0;
    margin-top: 0.2rem;
  }
`;

const ButtonWrapper = styled.div`
  text-align: right;
  margin-top: auto; /* push to bottom */
  padding-top: 0.8rem;

  a {
    text-decoration: none;
    color: white;
    background-color: var(--my-color3);
    border: none;
    border-radius: 6px;
    padding: 0.4rem 1rem;
    font-size: 0.85rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-weight: bold;
    display: inline-block;
    text-transform: uppercase;

    &:hover {
      background-color: var(--my-color2);
    }
  }
`;

const offres = [
  {
    img: logoWeb,
    title: "Web",
    path: "/creation-site-web-sur-mesure",
    contents: [
      {
        text: "<strong>Sites internet</strong> sur-mesure (vitrine, e-commerce, PWA)",
        html: true,
      },
      { text: "Refonte complète ou partielle" },
      { text: "Contenus optimisés SEO & visuels" },
    ],
    featured: true,
  },
  {
    img: logoMobile,
    title: "Mobile",
    path: "/developpement-application-mobile",
    contents: [
      {
        text: "<strong>Applications iOS & Android</strong> natives ou hybrides",
        html: true,
      },
      { text: "Modernisation d’app existantes" },
      { text: "Design UX mobile & contenus" },
    ],
    featured: true,
  },
  {
    img: logoAppWeb,
    title: "Logiciels sur-mesure",
    path: "/logiciel-metier-sur-mesure",
    subLabel: "Web & Desktop",
    contents: [
      {
        text: "<strong>Applications métiers</strong> 100% personnalisées (CRM, ERP, Extranets)",
        html: true,
      },
      {
        text: "Interface <strong>Web</strong> ou <strong>Desktop</strong> installable",
        html: true,
      },
      {
        text: "Connecteurs API & automatisations",
      },
    ],
    featured: true,
  },
  {
    img: logoAds,
    title: "Boost Ads",
    path: "/#contact",
    contents: [
      {
        text: "<strong>Campagnes Google / Meta / LinkedIn</strong>",
        html: true,
      },
      { text: "Optimisation ROI & reporting mensuel" },
      { text: "Setup unique + gestion mensuelle flexible" },
    ],
    featured: true,
  },
];

const OffresSection = () => {
  return (
    <Section className="offres-page">
      <Container>
        <HighlightTitle
          text="Nos offres"
          highlightWord="offres"
          bg="var(--my-color3)"
          rotateText={false}
          mainTextColor="var(--my-color3)"
          textColor="white"
        />
        <OffresContainer>
          {offres.map((offre, index) => (
            <AnimatedCard key={index}>
              <Card className={offre.featured ? "featured" : ""}>
                <CardImg>
                  <img src={offre.img} alt={offre.title} />
                </CardImg>
                <CardTitle>{offre.title}</CardTitle>
                {offre.subLabel && <SubLabel>{offre.subLabel}</SubLabel>}
                <ul style={{ marginTop: "0.5rem", paddingLeft: 0 }}>
                  {offre.contents.map((content, idx) => (
                    <Bullet key={idx}>
                      <FiCheckCircle size={14} />
                      {content.html ? (
                        <span
                          dangerouslySetInnerHTML={{ __html: content.text }}
                        />
                      ) : (
                        content.text
                      )}
                    </Bullet>
                  ))}
                </ul>
                <ButtonWrapper>
                  <a href={offre.path}>Découvrir</a>
                </ButtonWrapper>
              </Card>
            </AnimatedCard>
          ))}
        </OffresContainer>
      </Container>
    </Section>
  );
};

export default OffresSection;
